import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  colors: {
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
    background: {
      brandLight: '#3175CE',
      brandDark: '#1A305D',
      primary: '#FFF',
      secondary: '#E2E8F0',
      surfaceTeritiary: '#F7FAFC',
      yellow100: '#F4E9AD',
      yellow500: '#D69E2E',
      orange200: '#FBD38D',
      cyan100: '#C4ECF9',
      gray50: '#F7FAFC',
      blue50: '#EBF4FF',
      green100: '#C6F6D5',
      teal100: '#B2F5EA',
      red100: '#FED7D7',
      pink100: '#FED7E2',
      blue100: '#BEDAF8',
      purple100: '#E9D8FD',
      purple500: '#805AD5',
      surfaceSuccess: '#38A169',
      surfaceError: '#E53E3E',
    },
    border: {
      medium: 'gray.400',
      gray: '#CBD5E0',
      subtle: '#E2E8F0',
    },
    text: {
      primary: '#2D3748',
      secondary: '#4A5568',
      tertiary: 'gray.400',
      black: 'black',
      white: 'white',
      brandDark: '#1A305D',
      brandLight: '#3175CE',
      orange600: '#C05621',
      pink500: '#D53F8C',
      pink800: '#702459',
      blue700: '#2C4E82',
    },
  },
  components: {
    Input: {
      variants: {
        custom: {
          field: {
            height: '2rem',
            px: '0.625rem',
            borderRadius: '0.25rem',
            border: '1px solid',
            borderColor: 'border.gray',
            fontSize: 'sm',
            _placeholder: {
              color: 'text.secondary',
              fontSize: '0.875rem',
              fontWeight: 400,
              fontStyle: 'normal',
              lineHeight: 'normal',
            },
            _focus: {
              borderColor: 'text.brandLight',
              boxShadow: '0 0 0 1px #3175CE',
            },
            _invalid: {
              border: '2px solid',
              borderColor: 'background.surfaceError',
            },
          },
        },
      },
      defaultProps: {
        variant: 'custom',
      },
    },

    Select: {
      variants: {
        custom: {
          field: {
            height: '2rem',
            px: '0.625rem',
            borderRadius: '0.25rem',
            border: '1px solid',
            borderColor: 'border.gray',
            fontSize: 'sm',
            _placeholder: {
              color: 'text.secondary',
              fontSize: '0.875rem',
              fontWeight: 400,
              fontStyle: 'normal',
              lineHeight: 'normal',
            },
            _focus: {
              borderColor: 'text.brandLight',
              boxShadow: '0 0 0 1px #3175CE',
            },
            _invalid: {
              border: '2px solid',
              borderColor: 'background.surfaceError',
            },
          },
        },
      },
      defaultProps: {
        variant: 'custom',
      },
    },
  },
});
